import _ from "lodash";
import ActionTypeContrato from "./ActionTypeContrato";
import { ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";

export default class ActionContratoSet extends ActionTypeContrato {
    constructor(pathAtributo, valorASetear) {
        super(valorASetear);
        this.pathAtributo = pathAtributo;
    }

    ejecutar(estado, nuevoEstado) {
        const estado_Cargado_EstaVacio =
            Object.keys(estado.domain.cargado).length < 1 ? true : false;
        if (estado_Cargado_EstaVacio) {
            this.darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado);
            return nuevoEstado;
        }

        // let valorPorSetear=_.get(nuevoEstado.domain, pathAtributo);
        let valorDePropPorSetear = this.payload;
        let valorDePropCargada = _.get(estado.domain.cargado, this.pathAtributo, null);

        const sonValoresIguales = valorDePropPorSetear === valorDePropCargada;
        // const existeAtributoEnEstadoParaUpdate = _.has(nuevoEstado.paraUpdate, pathAtributo);

        if (sonValoresIguales) {
            if (_.has(estado.domain.update, this.pathAtributo)) {
                this.hacerALaPropiedadIgualASuVersionCargadaCuandoNoloEraAntes(estado, nuevoEstado);
                if (nuevoEstado.domain.nroUpdates === 0) {
                    nuevoEstado.flag.modoOperacion = ModosOp.OK;
                }
                return nuevoEstado;
            }
            return nuevoEstado;
        }

        //sonValoresDiferentes y la prop existe en el estado Update
        if (_.has(estado.domain.update, this.pathAtributo)) {
            if (valorDePropPorSetear === _.get(estado.domain.update, this.pathAtributo)) {
                return nuevoEstado;
            }
            this.hacerALaPropiedadDiferenteDeSuVersionCargadaPorEnesimaVez(estado, nuevoEstado);
            return nuevoEstado;
        }

        //sonValoresDiferentes y la prop NO existe en el estado Update
        this.hacerALaPropiedadDiferenteDeSuVersionCargadaPorPrimeraVez(estado, nuevoEstado);
        if (nuevoEstado.domain.nroUpdates >= 1) {
            nuevoEstado.flag.modoOperacion = ModosOp.MODIFICAR;
        }
        return nuevoEstado;
    }

    /**@abstract */
    darleUnNuevoValorALaPropiedadDelaNuevaEntidad(estado, nuevoEstado) {
        _.set(nuevoEstado.domain.screen, this.pathAtributo, this.payload);
    }

    /**@abstract */
    hacerALaPropiedadIgualASuVersionCargadaCuandoNoloEraAntes(estado, nuevoEstado) {
        const valorPropCargada = _.get(estado.domain.cargado, this.pathAtributo);
        _.set(nuevoEstado.domain.screen, this.pathAtributo, valorPropCargada);
        _.unset(nuevoEstado.domain.update, this.pathAtributo);
        nuevoEstado.domain.nroUpdates--;
    }

    /**@abstract */
    hacerALaPropiedadDiferenteDeSuVersionCargadaPorPrimeraVez(estado, nuevoEstado) {
        // nuevoEstado.domain.screen.tipoDoc = estado.domain.cargado.tipoDoc;
        _.set(nuevoEstado.domain.screen, this.pathAtributo, this.payload);

        if (this.payload !== null) {
            _.set(nuevoEstado.domain.update, this.pathAtributo, this.payload);
            nuevoEstado.domain.nroUpdates++;
        }
    }

    /**@abstract */
    hacerALaPropiedadDiferenteDeSuVersionCargadaPorEnesimaVez(estado, nuevoEstado) {
        _.set(nuevoEstado.domain.screen, this.pathAtributo, this.payload);

        if (this.payload !== null) {
            _.set(nuevoEstado.domain.update, this.pathAtributo, this.payload);
            return;
        }
        _.unset(nuevoEstado.domain.update, this.pathAtributo, this.payload);
        nuevoEstado.domain.nroUpdates--;
    }

}
